import React from 'react'
import { Link } from 'react-router-dom'

const WprkerPostTabsModal = () => {
  return (
   
    <div className='worker-post-bottom mt-4'>
        <div className='worker-post-bottom-box'>
            <div className='worker-post-box'>
                <div className='worker-post-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>chloelovesyou  <span>9h</span></h5>
                        <p>Send me moneyyyyyyyy!  </p>
                    </div>
                </div>
            </div>
            <div className='worker-post-box active-border'>
                <div className='worker-post-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>chloelovesyou  <span>12h</span></h5>
                        <p>Looking to send money to someone!  </p>
                    </div>
                </div>
                <div className='two-img-box position-relative'>
                    <ul className='d-flex flex-wrap position-relative'>
                        <li className='img-box'></li>
                        <Link rel='stylesheet' to='' className='btn btn-border btn-pink'>Subscription Only</Link>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default WprkerPostTabsModal
